import api from './api';

/**
 * سرویس مدیریت فعالیت‌ها
 */

// دریافت لیست فعالیت‌ها با فیلتر
export const getActivities = async (params = {}) => {
  try {
    const response = await api.get('/activities', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت آمار فعالیت‌ها
export const getActivityStats = async (dateRange = 'month') => {
  try {
    const response = await api.get('/activities/stats', { 
      params: { dateRange } 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// ایجاد فعالیت جدید
export const createActivity = async (activityData) => {
  try {
    const response = await api.post('/activities', activityData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت فعالیت‌های اخیر (از گزارشات)
export const getRecentActivity = async (limit = 10) => {
  try {
    const response = await api.get('/reports/activity', { 
      params: { limit } 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}; 